"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Button_1 = __importDefault(require("react-bootstrap/Button"));
var Link = function (props) {
    var _a = props.url, url = _a === void 0 ? '#' : _a, size = props.size, type = props.type, _b = props.target, target = _b === void 0 ? '_blank' : _b, _c = props.className, className = _c === void 0 ? '' : _c, variant = props.variant, children = props.children, onClick = props.onClick;
    var createLink = function () {
        switch (type) {
            case 'button':
                return (react_1.default.createElement(Button_1.default, { variant: variant, className: className, size: size, href: !onClick ? url : '#', onClick: onClick }, children));
                break;
            case 'link':
                return (react_1.default.createElement("a", { href: !onClick ? url : '#', target: target, className: className, onClick: onClick }, children));
                break;
            case 'href':
                return react_1.default.createElement(react_1.default.Fragment, null, url);
                break;
            default:
                return react_1.default.createElement(react_1.default.Fragment, null);
                break;
        }
    };
    return createLink();
};
Link.propTypes = {
    children: prop_types_1.default.any,
    url: prop_types_1.default.string,
    type: prop_types_1.default.oneOf(['button', 'link']),
    variant: prop_types_1.default.string,
    size: prop_types_1.default.string,
    target: prop_types_1.default.string,
    className: prop_types_1.default.any,
    onClick: prop_types_1.default.func,
};
exports.default = Link;
//# sourceMappingURL=Link.js.map